module.exports = __webpack_public_path__ + "static/media/icon_executive.fb2bdb91.svg";